import {useEffect} from "react";
import { Row } from "react-bootstrap";
import { useSelector,useDispatch } from "react-redux";

import Spinner from "../../Components/UI/Spinner/Spinner";
import { IReduxState } from "../../utils/types";
import FilteringForm from "./FilteringForm";

import "./style.css";
import { getLineItemInfoDemo } from "../../Redux/Actions/CLineItemDemoActions";

const ClineItemDemo = () =>{
  const IPfilteringDemoState = useSelector((state: IReduxState) => state.ClineItemDemo);
  const AuthState = useSelector((state: IReduxState) => state.Auth);

  const dispatch = useDispatch();

  const autoClearOptions = [
    { label: "After 30 Min", value: 0.5 },
    { label: "After 1 Hour", value: 1 },
    { label: "After 2 Hours", value: 2 },
    { label: "After 4 Hours", value: 4 },
    { label: "After 8 Hours", value: 8 },
    { label: "After 24 Hours",value: 24 },
  ];

  let adsTypeDefaultSelection:string ='';
  let ads_shown_list:any = [{value:'with',label:'With User ID'},{value:'without',label:'Without User ID'}]; 
  if(AuthState?.line_item_id_demo && AuthState?.line_item_without_id_demo){
    adsTypeDefaultSelection='with';
    ads_shown_list = [{value:'with',label:'With User ID'},{value:'without',label:'Without User ID'}]; 
  }else if(AuthState?.line_item_id_demo){
    adsTypeDefaultSelection='with';
    ads_shown_list = [{value:'with',label:'With User ID'}]; 
  }else if(AuthState?.line_item_without_id_demo){
    adsTypeDefaultSelection='without';
    ads_shown_list = [{value:'without',label:'Without User ID'}]; 
  }

  useEffect(() => {
    dispatch(getLineItemInfoDemo(adsTypeDefaultSelection)); 
  }, [adsTypeDefaultSelection,dispatch]);

  return (
    <>
      <Row className="d-flex justify-content-center mt-3"><Row><h3 className="module_title" style={{marginBottom:'0px'}}>DEMO IP Filtering<p>Expedite a collection of "controlled ads" events from a specific Test IP</p></h3></Row></Row>

      {IPfilteringDemoState.loading && (<div className="popUpUser"><Spinner className="m-2" color={"primary"}></Spinner></div>)} 

      {!IPfilteringDemoState.getLineInfoLoader && <FilteringForm autoClearOptions={autoClearOptions} IPfilteringDemoState={IPfilteringDemoState} adsTypeDefaultSelection={adsTypeDefaultSelection} ads_shown_list={ads_shown_list} /> }
    </>
  );
}

export default ClineItemDemo;